import { HTags } from '@shared/src/datatypes/HTags';
import { ShipmentDeliveryLineBatchInfoDto } from '@shared/src/dtos/shipment/delivery/ShipmentDeliveryLineBatchInfoDto';
import { PalletTypes } from '@shared/src/enums/PalletTypes';

export class ECMRDeliveryLineDto {
	public order: string;
	public line: number;
	public reference: string;
	public description: string;
	public palletType: PalletTypes;
	public wDimension: number;
	public yDimension: number;
	public hDimension: number;
	public m3: number;
	public quantity: number;
	public kg: number;
	public netKg: number;
	public boxes: number;
	public bags: number;
	public sacks: number;
	public litres: number;
	public palletCount: number;
	/*** Les línies del CMR NOMÉS coneixen el publicTags de la línia original (privateTags no s'hi propaga) */
	public publicTags: HTags;
	public batchInfo: ShipmentDeliveryLineBatchInfoDto;
}
